import type { FilterConfigGroupedSelect } from 'c-pagination/types';
import { CustomFilterConfigType } from 'c-pagination/types';

const campaignTypeFilter: FilterConfigGroupedSelect = {
    key: 'filter.type',
    label: 'Modules.Main.Campaigns.DataStatus.campaignTypeFilter.label',
    type: CustomFilterConfigType.GroupedSelect,
    groups: [
        {
            label: 'Modules.Main.Campaigns.DataStatus.campaignTypeFilter.linear',
            options: [
                {
                    label: 'Modules.Main.Campaigns.DataStatus.campaignTypeFilter.options.default',
                    value: 'default',
                },
                {
                    label: 'Models.Campaign.type.linear',
                    value: 'linear',
                },
            ],
        },
        {
            label: 'Modules.Main.Campaigns.DataStatus.campaignTypeFilter.programmatic',
            options: [
                {
                    label: 'Models.Campaign.type.hivestack_uk',
                    value: 'hivestack_uk',
                },
                {
                    label: 'Models.Campaign.type.vistar_us',
                    value: 'vistar_us',
                },
                {
                    label: 'Models.Campaign.type.placeexchange_us',
                    value: 'placeexchange_us',
                },
                {
                    label: 'Models.Campaign.type.vistar_uk',
                    value: 'vistar_uk',
                },
                {
                    label: 'Models.Campaign.type.hivestack_us',
                    value: 'hivestack_us',
                },
                {
                    label: 'Models.Campaign.type.vistar_us2',
                    value: 'vistar_us2',
                },
            ],
        },
    ],
};

export default campaignTypeFilter;
